import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { AppService } from '../app.service';
import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';
import { PatientService } from 'projects/icemedx-lib/src/services/patient/patient.service';

import {
  IcedashboardiconSettings
} from 'projects/icemedx-lib/src/components/models/icesettings';
import { IceTypes } from 'projects/icemedx-lib/src/models/icetypes';
import { Iceutility } from 'projects/icemedx-lib/src/services/iceutility';
import { Router } from '@angular/router';

@Component({
  selector: 'app-patientdashboard',
  templateUrl: './patientdashboard.component.html',
  styleUrls: ['./patientdashboard.component.scss'],
  providers: [AppService, IceNavService]
})
export class PatientdashboardComponent implements OnInit {

  messagesOn: boolean = true;
  iconSettings: IcedashboardiconSettings = new IcedashboardiconSettings();
  thisYear = Iceutility.getYear();

  private unreadMessagesReadySub: Subscription = this.navSvc.onUnReadMessageReady().subscribe(
    msgs => {
      this.iconSettings.messageCount = this.navSvc.getUnreadMessageCount();
    },
    error => {
    });

  constructor(private appSvc: AppService, private loginSvc: LoginService, private navSvc: IceNavService, ptSvc: PatientService, private router: Router) {
    this.messagesOn = appSvc.getMainAppChildMode() == false;
    this.appSvc.defaultMenus();
    this.appSvc.addBreadcrumb("Patient Dashboard", {}, true, "");

    ptSvc.getOrders(appSvc.getCurrentAccountType() == IceTypes.ACCOUNT_TYPE.actPatient ? appSvc.getCurrentAccount() : appSvc.getCurrentPatient(), "", "", "", "", 0, 250, "", true).subscribe(
      data => {
        if (data != null) {
          this.iconSettings.ordersCount = data.length;
        }
      },
      error => {
        console.log(error);
      });

    this.iconSettings.messageRoute = this.navSvc.buildRoute("messages/inbox", false);
    this.iconSettings.ordersRoute = this.navSvc.buildRoute("patientportal/orders", false);
    this.iconSettings.tasksRoute = this.navSvc.buildRoute("ToDoList", true);
    this.iconSettings.alertsRoute = this.navSvc.buildRoute("Alerts", true);
  }

  ngOnInit() {
    this.appSvc.refreshMenus();
  }

  //////////////////////////////////
  // Toolbar Events
  onToolbarMenuItemOpen(event) {
    this.appSvc.onDefaultToolbarMenuItemOpen(event);
  }
  onToolbarMenuItemClick(event) {
    this.appSvc.onDefaultToolbarMenuItemClick(event, this.router);
  }

}
